import { useFetchAllActivityHistoryFilters } from '@user/features/Activity/hooks/useFetchAllActivityHistoryFilters'

export function useData() {
  const filtersStatus = useFetchAllActivityHistoryFilters()

  return { filtersStatus }
}
